import {Component, State, Prop, Event, EventEmitter, h, Listen} from '@stencil/core';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'fdi-wizard',
  styleUrl: 'fdi-wizard.scss',
  shadow: true,
})
export class FDIWizard {

  @Prop() __targetFI: string;
  @Prop() __ajaxUrl: string = '/wp-admin/admin-ajax.php';
  @Prop() __templateId: string;
  @Prop() __existingAnswers: string;
  @Prop() __wizardId: string;
  @Prop() __master: string; // the id of the wizards component this is in if any

  @State() wizardId: string;
  @State() wizard: any = null;
  @State() templateLoaded: boolean = false;
  @State() noTemplateText: string = 'Loading...';
  @State() wizardComplete: boolean = false;
  @State() currentQuestionIndexes: Array<number> = [];
  @State() searchQuery: string = '';
  @State() slides: Array<any> = [];
  @State() currentSlide: number = 0;
  @State() existingAnswers: any = null;
  @State() renderTrigger: boolean = true;
  @State() multiSelectOptions: any = {
    showSelectedText: 'Show Selected',
    hideSelectedText: 'Hide Selected'
  }
  @State() textInputValues: any = {};

  @Event({
    eventName: 'fdi_wc_wizardCompleted',
    bubbles: true,
    cancelable: true,
  }) wizardCompleted: EventEmitter
  finish(){
    let formatted_answers = {};
    if (this.wizard && this.wizard.hasOwnProperty('questions')){
      this.wizard.questions.forEach((q) => {
        formatted_answers[q.fi] = q.answer || [];
      });
    }
    this.wizardComplete = true;
    this.wizardCompleted.emit({
      is_complete: this.wizardComplete,
      wizard: this.wizard,
      formatted_answers,
      wizardId: this.wizardId,
      master: this.__master
    });
  }

  @Listen('fdi_wc_input_change')
  fdi_wc_input_change__handler( ev ){
    let customValuePrefix = 'fdi_wizard_custom_value_';
    let searchQueryId = 'fdi_wizard_search_query';
    let id = ev.target.id;
    const {detail} = ev;
    if ( detail.meta && detail.meta.wizardId && detail.meta.wizardId === this.wizardId ) {
      this.wizard.questions[detail.meta.idx].answer = [detail.newValue];
    }
    if ( id ){
      if ( id.includes( customValuePrefix ) ){
        console.log('if')
        let questionNum = id.replace( customValuePrefix, '' );
        this.textInputValues[id] = {
          newValue: ev.detail.newValue,
          questionNum,
        };
      }
      else if ( id === searchQueryId ){
        console.log('elseif')
        this.searchQuery = ev.detail.newValue;
        this.textInputValues[id] = {
          newValue: ev.detail.newValue,
        }
      }
    }
  }

  @Listen('fdi_wc_multi-input_change')
  fdi_wc_multiInput_change__handler( ev ){
    const { detail = false } = ev;
    if (detail) {
      const { newValue, meta: { wizardId = false, type = false, idx = false } = {} } = detail;
      if ( wizardId === this.wizardId && type === 'multi_input' && idx) {
        this.wizard.questions[idx].answer = [
          ...newValue,
        ];
      }
    }
  }

  @Listen('fdi_wc_multiselect_change')
  fdi_wc_multiselect_change__handler( ev ){
    let data = ev.detail;
    if ( data ){
      let meta = data.meta;
      if ( meta.wizardId && meta.wizardId === this.wizardId ){
        if ( meta.type && meta.type === 'multiselect' && meta.hasOwnProperty( 'idx' ) ){
          this.wizard.questions[meta.idx].answer = [
            ...data.newValue,
          ];
        }
      }
    }
  }

  @Listen('fdi_wc_datetimepicker_change')
  fdi_wc_datetimepicker_change__handler( ev ){
    let data = ev.detail;
    if ( data ){
      let meta = data.meta;
      if ( meta.wizardId && meta.wizardId === this.wizardId ){
        if ( meta.type && meta.type === 'datetimepicker' && meta.hasOwnProperty( 'idx' ) ){
          this.wizard.questions[meta.idx].answer = [data.newValue];
        }
      }
    }
  }

  @Listen('fdi_wc_image_uploader_load')
  fdi_wc_image_uploader_load__handler( ev ){
    let data = ev.detail;
    console.log({data})
    if ( data ){
      let meta = data.meta;
      if ( meta.wizardId && meta.wizardId === this.wizardId ){
        if ( meta.type && meta.type === 'image' && meta.hasOwnProperty( 'idx' ) && meta.wizardId === this.wizardId ){
          this.wizard.questions[meta.idx].answer = [data.src];
        }
      }
    }
    console.log({lewizards: this.wizard})
  }

  addCustomAnswer(idx, id){
    if (
      this.wizard &&
      this.wizard.hasOwnProperty( 'questions' ) &&
      Array.isArray( this.wizard.questions ) &&
      this.wizard.questions.hasOwnProperty( idx )
    ){
      if ( this.textInputValues.hasOwnProperty( id ) ){
        let value = this.textInputValues[ id ].newValue;
        let qs = this.wizard.questions;
        if ( qs && qs.hasOwnProperty( idx ) ){
          let ops = qs[ idx ].options.data;
          if ( !ops.includes( value ) )
            qs[ idx ].options.data.push( value );
          if ( !qs[ idx ].answer.includes( value ) )
            qs[ idx ].answer.push( value );
          this.renderTrigger = !this.renderTrigger;
        }
      }
    }
  }

  addAllSelections(question){
    question.answer = JSON.parse(JSON.stringify(question.options.data));
    this.renderTrigger = !this.renderTrigger;
  }

  removeAllSelections(question){
    question.answer = [];
    this.renderTrigger = !this.renderTrigger;
  }

  removeAnswer(idx, answers){
    answers.splice(idx, 1);
    this.renderTrigger = !this.renderTrigger;
  }

  showAnswers(question){
    question.show_answers = true;
    this.renderTrigger = !this.renderTrigger;
  }

  hideAnswers(question){
    question.show_answers = false;
    this.renderTrigger = !this.renderTrigger;
  }

  processExistingAnswers(){
    if (
      this.existingAnswers &&
      this.wizard &&
      this.wizard.hasOwnProperty('questions') &&
      Array.isArray(this.wizard.questions)
    ){
      this.wizard.questions.forEach((q) => {
        if (this.existingAnswers.hasOwnProperty(q.fi))
          this.existingAnswers[q.fi].forEach((a) => {
            if (!q.answer.includes(a)) q.answer.push(a);
          });
      });
    }
  }

  loadSlides(){
    let questionsPerSlide = this.wizard.questions_per_slide;
    let questionCount = this.wizard.questions.length;
    let indexArr = [];
    for (let j = 0; j < questionCount; j++){
      indexArr.push(j);
    }
    for (let i = 0; i < questionCount; i += questionsPerSlide){
      this.slides.push(indexArr.slice(i, i + questionsPerSlide));
    }
  }

  goToInitialSlide(){
    if (this.__targetFI){
      this.skipToFriendlyIndex(this.__targetFI);
    }
    else{
      this.moveToSlideContainingIndex(0);
    }
  }

  async loadTemplate(){
    let data = new URLSearchParams();
    data.append('action', 'fdi_fetch_wizard');
    data.append('templateId', this.__templateId);
    console.log({
      ajaxurl: this.__ajaxUrl,
      data
    })
    axios.post(this.__ajaxUrl, data).then((r) => {
      console.log({
        wizardResponse:r,
      });
      if (r.hasOwnProperty('data') && r.data.hasOwnProperty('wizard')){
        this.wizard = r.data.wizard;
        this.templateLoaded = true;
        this.processExistingAnswers();
        this.loadSlides();
        this.goToInitialSlide();
      }
    }).catch((err) => {
      console.log({
        wizardError: err,
      });
    });

  //   let test = {
  //     "title": "Comparison Page Data",
  //     "finish_wizard_text": "Submit",
  //     "questions_per_slide": 5,
  //     "questions": [
  //         {
  //             "text1": "Header Title",
  //             "text2": "",
  //             "fi": "header_title",
  //             "is_required": false,
  //             "allow_custom_answer": true,
  //             "answer": [],
  //             "default_answer": [],
  //             "show_answers": false,
  //             "type": "text",
  //             "options": {
  //                 "source_type": null,
  //                 "source": null,
  //                 "data": null,
  //                 "data_type": null
  //             }
  //         },
  //         {
  //             "text1": "Header Paragraph",
  //             "text2": "",
  //             "fi": "header_paragraph",
  //             "is_required": false,
  //             "allow_custom_answer": true,
  //             "answer": [],
  //             "default_answer": [],
  //             "show_answers": false,
  //             "type": "text",
  //             "settings": {
  //               "useTextArea": true
  //             },
  //             "options": {
  //                 "source_type": null,
  //                 "source": null,
  //                 "data": null,
  //                 "data_type": null
  //             }
  //         },
  //         {
  //             "text1": "Left Vehicle Image",
  //             "text2": "",
  //             "fi": "left_vehicle_image",
  //             "is_required": false,
  //             "allow_custom_answer": true,
  //             "answer": [],
  //             "default_answer": [],
  //             "show_answers": false,
  //             "type": "image",
  //             "options": {
  //                 "source_type": null,
  //                 "source": null,
  //                 "data": null,
  //                 "data_type": null
  //             }
  //         },
  //         {
  //             "text1": "Right Vehicle Image",
  //             "text2": "",
  //             "fi": "right_vehicle_image",
  //             "is_required": false,
  //             "allow_custom_answer": true,
  //             "answer": [],
  //             "default_answer": [],
  //             "show_answers": false,
  //             "type": "image",
  //             "options": {
  //                 "source_type": null,
  //                 "source": null,
  //                 "data": null,
  //                 "data_type": null
  //             }
  //         },
  //         {
  //             "text1": "H2 Paragraphs",
  //             "text2": "",
  //             "fi": "paragraphs",
  //             "is_required": false,
  //             "answer": [],
  //             "default_answer": [],
  //             "show_answers": false,
  //             "type": "multi_input",
  //             "settings": {
  //                 "inputSettings": {
  //                     "useTextArea": true
  //                 }
  //             },
  //             "options": {
  //                 "source_type": null,
  //                 "source": null,
  //                 "data": [],
  //                 "data_type": "array"
  //             }
  //         }
  //     ]
  // };

  //   this.wizard = test;
  //   this.templateLoaded = true;
  //   this.processExistingAnswers();
  //   this.loadSlides();
  //   this.goToInitialSlide();
  }

  moveToSlideContainingIndex(idx){
    let slidesAmt = this.slides.length;
    for (let i = 0; i < slidesAmt; i++){
      if (this.slides[i].includes(idx)){
        this.currentQuestionIndexes = this.slides[i];
        this.currentSlide = i;
      }
    }
  }

  skipToFriendlyIndex(fi){
    if (this.wizard && this.wizard.hasOwnProperty('questions') && Array.isArray(this.wizard.questions)){
      let foundIndex = false;
      let questionsLength = this.wizard.questions.length;
      for (let i = 0; i < questionsLength; i++){
        let q = this.wizard.questions[i];
        if ((q.is_required && q.answer.length === 0) || q.fi === fi){
          this.moveToSlideContainingIndex(i);
          foundIndex = true;
          break;
        }
      }
      if (!foundIndex){
        this.moveToSlide(0);
      }
    }
  }

  matchesSearchQuery(string){
    if (this.searchQuery === '') return true;
    let rgx = new RegExp(this.searchQuery.toLowerCase(), 'g');
    return String(string).toLowerCase().match(rgx);
  }

  moveToSlide(idx){
    this.currentQuestionIndexes = this.slides[idx];
    this.currentSlide = idx;
  }

  nextSlide(){
    this.moveToSlide(this.currentSlide + 1);
  }

  prevSlide(){
    this.moveToSlide(this.currentSlide - 1);
  }

  async componentWillLoad() {
    this.wizardId = this.__wizardId ? this.__wizardId : uuidv4();
    if ( this.__existingAnswers ){
      this.existingAnswers = JSON.parse(this.__existingAnswers);
    }
    await this.loadTemplate();
  }

  handleAnswer(e, i){
    if (
      this.wizard &&
      this.wizard.hasOwnProperty('questions') &&
      this.wizard.questions.hasOwnProperty(i) &&
      this.wizard.questions[i].hasOwnProperty('type')
    ){
      let q = this.wizard.questions[i];
      if ( q.type === 'radio' ){
        let value = e.target.value;
        value = value === 'true';
        q.answer = [value];
      }
      this.renderTrigger = !this.renderTrigger;
    }
  }

  render() {

    let _currentQuestionsObj = {};
    let _currentQuestions = [];
    let _currentQuestionsKeys = [];

    let _canGoToNextSlide = false;
    let _canGoToPrevSlide = false;
    let _canFinishWizard = false;

    let question = (
      <div class={'question'}>

      </div>
    );

    let templateLoaded = '';
    let templateNotLoaded = (
      <div>
        {this.noTemplateText}
      </div>
    );

    let wizardTitle = '';
    let searchInput = '';

    if (this.templateLoaded && this.wizard && this.wizard.hasOwnProperty('questions') && Array.isArray(this.wizard.questions)){

      let length = this.wizard.questions.length;
      let added = 0;
      let questionsPerSlide = this.wizard.questions_per_slide;
      for (let i = 0; i < length; i++){
        if (added === questionsPerSlide) break;
        if (this.slides[this.currentSlide].includes(i)){
          _currentQuestionsObj[i] = this.wizard.questions[i];
          added++;
        }
      }

      _currentQuestionsKeys = Object.keys(_currentQuestionsObj);
      if (_currentQuestionsKeys.length > 0){
        _currentQuestions = Object.values(_currentQuestionsObj);
      }

      /**
       * Next slide button
       */
      _canGoToNextSlide = true;
      _currentQuestions.forEach((q) => {
        if (q.answer.length === 0 && q.is_required === true) {
          _canGoToNextSlide = false;
          return false;
        }
      });
      if (this.currentQuestionIndexes.includes(this.wizard.questions.length - 1) && !this.wizard.show_review_page){
        _canGoToNextSlide = false;
      }

      /**
       * Prev slide button
       */
      _canGoToPrevSlide = true;
      _currentQuestions.forEach((q) => {
        if (q.answer.length === 0 && q.is_required === true || this.currentQuestionIndexes.includes(0)) {
          _canGoToPrevSlide = false;
          return false;
        }
      });

      /**
       * Finish / submit wizard button
       */
      _canFinishWizard = true;
      this.wizard.questions.forEach((q) => {
        if (q.answer.length === 0 && q.is_required === true) {
          _canFinishWizard = false;
          return false;
        }
      });

      question = _currentQuestionsKeys.map((idx) => {

        let i = parseInt(idx);
        let question = this.wizard.questions[i];

        let text1 = '';
        if(question.text1){
          text1 = (
            <div class={'text1'}>
              {question.text1}
            </div>
          );
        }

        let text2 = '';
        if (question.text2){
          text2 = (
            <div class={'text2'}>
              {question.text2}
            </div>
          );
        }

        let questionContent = '';
        if ( question.type === 'text' ) {
          const inputSettings = {
            ...question?.settings,
            placeholder: "Enter text",
            meta: {
              wizardId: this.wizardId,
              idx, 
              type: 'text'
            }
          };

          let input = (
            <fdi-text-input
              key={ idx }
              __settings={inputSettings}
              __value={ question.answer }
            />
          );

          questionContent = (
            <div class={'content'}>
              { input }
            </div>
          );
        }
        else if ( question.type === 'multi_input' ) {
          const inputSettings = {
            ...question?.settings,
            meta: {
              wizardId: this.wizardId,
              idx,
              type: 'multi_input'
            }
          };

          let input = (
            <fdi-multi-input
              key={ idx }
              __inputs={question.answer}
              __settings={inputSettings}
            />
          );

          questionContent = (
            <div class={'content'}>
              { input }
            </div>
          );
        }
        else if ( question.type === 'image' ) {
          const imageSettings = {
            meta: {
              type: 'image',
              wizardId: this.wizardId,
              idx,
            }
          };
          
          let imageUpload = (
            <fdi-image-uploader 
              __settings={imageSettings}
              __value={question.answer[0]}
            />
          );
          questionContent = (
            <div class={'content'}>
              { imageUpload }
            </div>
          );
        }
        else if (question.type === 'multi_select' && Array.isArray(question.options.data)){

          let multiselectSettings = {
            tagMode: false ,
            input: {
              placeholder: 'Enter Value or Search'
            },
            meta: {
              type: 'multiselect',
              wizardId: this.wizardId,
              idx,
            }
          };

          let multiselect = (
            <fdi-multiselect
              key={ idx }
              __settings={ multiselectSettings }
              __opts={ question.options.data }
              __selected={ question.answer }
            />
          );

          questionContent = (
            <div class={'content'}>
              { multiselect }
            </div>
          );

        }
        else if (question.type === 'radio' && typeof question.options.data === 'object'){
          let radioOptions = Object.entries(question.options.data).map((radio:Array<any>) => {
            let display = radio[0];
            let value = radio[1];
            if (
              question.answer.length === 0 &&
              question.hasOwnProperty('default_answer') &&
              Array.isArray(question.default_answer) &&
              question.default_answer.length > 0
            ){
              question.answer = JSON.parse(JSON.stringify(question.default_answer));
            }
            let selected = question.answer.includes(value);
            return (
              <div>
                <label>{display}</label>
                <input checked={selected} name={question.fi} type={'radio'} value={value} onChange={(e) => this.handleAnswer(e, i)} />
              </div>
            );
          });
          questionContent = (
            <div class={'content'}>
              <div class={'radioOptions'}>
                {radioOptions}
              </div>
            </div>
          );
        } 
        else if (question.type === 'datetimepicker') {
          let datetimepicker = (
            <fdi-date-time-picker 
              key={idx}
              __datetime={question.answer[0]}
              __dateonly={question.options.date_only}
              __settings={{
                meta: {
                  type: 'datetimepicker',
                  wizardId: this.wizardId,
                  idx,
                }
              }}
            />
          );
          questionContent = (
            <div>
              { datetimepicker }
            </div>
          );
        }

        let prevButtonClass = 'navButton';
        if (!_canGoToPrevSlide) prevButtonClass += ' grayColor noPointerEvents';
        let prevButton = (
          <div class={prevButtonClass} onClick={() => this.prevSlide()}>
            <span>Previous</span>
          </div>
        );

        let finishWizardText = this.wizard.finish_wizard_text || 'Finish';
        let submitButtonClass = 'navButton';
        if (!_canFinishWizard) submitButtonClass += ' grayColor noPointerEvents';
        let submitButton = (
          <div class={submitButtonClass} onClick={() => this.finish()}>
            <span>{finishWizardText}</span>
          </div>
        );

        let nextButtonClass = 'navButton';
        if (!_canGoToNextSlide) nextButtonClass += ' grayColor noPointerEvents';
        let nextButton = (
          <div class={nextButtonClass} onClick={() => this.nextSlide()}>
            <span>Next</span>
          </div>
        );

        let navigationContainer = (
          <div class={'navigationContainer'}>
            {prevButton}
            {submitButton}
            {nextButton}
          </div>
        );

        return (
          <div class={'question'}>
            <div class={'titleContainer'}>
              {text1}
              {text2}
            </div>
            {questionContent}
            {navigationContainer}
          </div>
        );

      });

      if (this.wizard.title){
        wizardTitle = (
          <div class={'titleContainer'}>
            <h2 class={'title'}>{this.wizard.title}</h2>
          </div>
        );
      }

      templateLoaded = (
        <div class={'fdi'} id={'wizard'}>
          {wizardTitle}
          {searchInput}
          {question}
        </div>
      );
      templateNotLoaded = '';

    }

    return (
      <div>
        {templateLoaded}
        {templateNotLoaded}
      </div>
    );
  }
}
